<template>
    <section>
        <div class="modal-card" style="width: 50vw; height: 70vh">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ __('strings.discount.discount_program') }}</p>
                <button
                    type="button"
                    class="delete"
                    @click="$emit('toggleDiscountProgramModal')"/>
            </header>
            <section class="modal-card-body">
                <b-table :data="discounts"
                         :total="discounts.length"
                         :per-page="10"
                         :loading="tableShouldLoad"
                         paginated
                         striped bordered>
                    <b-table-column label="Settimana" v-slot="props">
                        {{ getWeekNumber(props.row.start_date) }}
                    </b-table-column>
                    <b-table-column label="Data di inizio" v-slot="props">
                        {{ getHumanDate(props.row.start_date) }}
                    </b-table-column>
                    <b-table-column label="Data di fine" v-slot="props">
                        {{ getHumanDate(props.row.end_date) }}
                    </b-table-column>
                    <b-table-column label="Website" v-slot="props">
                        {{ getWebsites(props.row) }}
                    </b-table-column>
                </b-table>
            </section>
        </div>
    </section>
</template>

<script>

import moment from "moment";

export default {
    data() {
        return {
            tableShouldLoad: false,
            discounts: [],
            filters: {
                status: null
            }
        }
    },
    beforeMount() {
        this.handleDiscountProductSearch();
    },
    methods: {
        handleDiscountProductSearch() {
            this.tableShouldLoad = true;
            axios.get('/discount_plan/filter', {params: {status: 'applied'}})
                .then(response => {
                    this.discounts = response.data;
                    axios.get('/discount_plan/filter', {params: {status: 'planned'}})
                        .then(response => {
                            this.discounts.push(...response.data);
                            this.discounts.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
                        }).catch((error) => {
                        console.error(error);
                        this.tableShouldLoad = false;
                    });
                }).catch((error) => {
                console.error(error);
                this.tableShouldLoad = false;
            })
                .finally(() => {
                    this.tableShouldLoad = false;
                })
        },
        handleOnChangeStatus(value) {
            this.filters.status = value;
            this.handleDiscountProductSearch();
        },
        getHumanDate(date) {
            return moment(date).format('DD MMM YYYY HH:mm');
        },
        getWeekNumber(date) {
            return moment(date).week();
        },
        getWebsites(row) {
            return _.map(row.websites, 'name').join(', ')
        }
    }
}
</script>

